export default __webpack_public_path__ + "static/media/reset-image.79859982.png";